import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import Heatmap from './modules/Heatmap';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state: any) => ({
    // add any states that need to be persisted beyond the current session
  }),
});

export default new Vuex.Store({
  state: {
    // Layers
    layers: [],
    basemaps: [
      {name: 'Dark Greyscale', url: 'dark-gray-vector', active: true},
      {name: 'Greyscale', url: 'gray-vector', active: false},
      {name: 'Satellite (GeoNova)', url: 'https://nsgiwa.novascotia.ca/arcgis/rest/services/BASE/BASE_NSODB_10k_WM84/MapServer', active: false},
      {name: 'Satellite', url: 'satellite', active: false},
      {name: 'Topographic', url: 'topo-vector', active: false},
      {name: 'Streets', url: 'streets-vector', active: false},
    ],

    // grey
    vectorStyle: 'https://keithpower.maps.arcgis.com/sharing/rest/content/items/6c4ff7555f7b4822b97699178d63284b/resources/styles/root.json',
    // red
    vectorStyleAlt: 'https://keithpower.maps.arcgis.com/sharing/rest/content/items/141e496ddb0c4e9bb30f92fd6a85b456/resources/styles/root.json',

    // EsriMap
    map: null,
    mapView: null,
    center: null,
    zoom: null,

  },

  mutations: {
    SET_BASEMAP(state: any, basemap: any) {
      state.map.basemap = basemap;
      state.basemaps.forEach((item: any, index: number) => {
          if (item.url === basemap) {
              item.active = true;
          } else {
              item.active = false;
          }
      });
    },
    TOGGLE_LAYER(state: any, layer: any) {
      // this is not clear, should be using ids
      state.map.layers.forEach((item: any, index: number) => {
        if (layer.hasOwnProperty('vectorLayer')) {
          if (layer.vectorLayer === item.parsedUrl.path) {
            item.visible = !item.visible;
          }
        } else {
          if (layer.url === item.parsedUrl.path) {
            item.visible = !item.visible;
          }
        }
      });
    },
    SET_MAP(state: any, payload: any) {
      state.map = payload;
    },
    SET_MAP_VIEW(state: any, payload: any) {
      state.mapView = payload;
    },
  },

  actions: {
    setBasemap(context, basemap) {
      context.commit('SET_BASEMAP', basemap);
    },
    toggleLayer(context, layer) {
      context.commit('TOGGLE_LAYER', layer);
    },
    setMap(context, payload) {
      context.commit('SET_MAP', payload);
    },
    setMapView(context, payload) {
      context.commit('SET_MAP_VIEW', payload);
    },
    notify(context, message) {
      // no state/mutations, this is only used to subscribe to actions in other components
    },
  },

  modules: {
    heatmap: Heatmap,
  },

  plugins: [vuexLocal.plugin],
});
